import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingName = (state: IState) => {
  return pathOr('', ['offerData', 'newObject', 'name'], state);
};
